module.exports = __webpack_public_path__ + "img/bg_hiking.6a2f16e2.jpg";